import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import DownloadAppPopup from "./DownloadAppPopup";

// Controller decides whether to show the popup:
// - Only on mobile devices
// - Only if user came from external link (not from muscatwhereto or localhost)
// - Only if the current route contains "events"
const DownloadAppController = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const hasCheckedInitial = useRef(false);
  const lastCheckedPath = useRef("");

  useEffect(() => {
    // Don't show if already dismissed
    if (dismissed) return;

    const currentPath = location.pathname.toLowerCase();
    const isEventRoute = currentPath.includes("event");

    // Only check on initial mount or when navigating to a new event route
    if (!isEventRoute) {
      setShow(false);
      return;
    }

    // Skip if we already checked this exact path
    if (lastCheckedPath.current === currentPath && hasCheckedInitial.current) {
      return;
    }

    lastCheckedPath.current = currentPath;

    // Check if app is running in standalone mode (PWA/In-App)
    // iOS: window.navigator.standalone is true when added to home screen (PWA mode)
    // Android: window.matchMedia('(display-mode: standalone)') works for PWA
    // Also check for fullscreen and minimal-ui display modes (PWA indicators)
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.matchMedia("(display-mode: fullscreen)").matches ||
      window.matchMedia("(display-mode: minimal-ui)").matches ||
      window.navigator.standalone === true ||
      document.referrer.includes("android-app://");

    // Better mobile detection for iOS
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isAndroid = /Android/.test(navigator.userAgent);
    const isMobileDevice = isIOS || isAndroid;
    const isMobileViewport = window.innerWidth <= 768;
    const isMobile = isMobileDevice || isMobileViewport;

    // Check if referrer is external (not from our domain)
    // iOS Safari sometimes doesn't send referrer, so empty referrer is considered external
    const referrer = document.referrer.toLowerCase();
    const isExternalReferrer =
      referrer === "" ||
      (!referrer.includes("muscatwhereto") &&
        !referrer.includes("localhost") &&
        !referrer.includes("mwtstaging.cfd") &&
        !referrer.includes("127.0.0.1"));

    // Show popup only if:
    // 1. NOT running in standalone/PWA mode (must be in mobile browser)
    // 2. User came from external source (not muscatwhereto or localhost)
    // 3. On mobile device (iOS/Android or screen width <= 768px)
    // 4. Current route contains "event"
    // IMPORTANT: Only show in mobile browser, NOT in PWA/standalone mode
    if (!isStandalone && isExternalReferrer && isMobile && isEventRoute) {
      setShow(true);
      hasCheckedInitial.current = true;
    } else {
      setShow(false);
    }
  }, [location.pathname, dismissed]);

  const handleClose = () => {
    setShow(false);
    setDismissed(true);
  };
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  if (!show) return null;
  return (
    <>
      {isStandalone || window.isNative == true ? (
        <></>
      ) : (
        <DownloadAppPopup onClose={handleClose} />
      )}
    </>
  );
};

export default DownloadAppController;
